import type { FC } from 'react';
import { Stack, TableCell } from '@mui/material';

import OverdueActionItemsBell from 'src/components/survey/components/OverdueActionItemsBell';
import type { CellProps } from 'src/components/survey/SurveySelectionPage/components/SurveyTableView/types';

import { styles } from './cell.styles';

const NotificationCell: FC<CellProps> = ({ columns, survey }) => (
  <TableCell
    sx={styles.cell(columns.overdueActionItemCount.width)}
    padding="none"
  >
    {survey.overdueActionItemCount > 0 && (
      <Stack
        direction="row"
        sx={{
          justifyContent: 'center',
        }}
      >
        <OverdueActionItemsBell count={survey.overdueActionItemCount} />
      </Stack>
    )}
  </TableCell>
);

export default NotificationCell;
